module.exports = __webpack_public_path__ + "img/mobilepeople.3ddb6440.svg";